<template>
    <div v-html="content">
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    import { ContentService } from '../../services'

    export default {
        name: 'app-content',
        props: ['name'],
        data: function () {
            return {
                content: '',
                last_locale: ''
            };
        },
        watch: {
            $route:async function () {
                if (this.last_locale != this.locale) {
                    await this.load();
                }
                this.last_locale = this.locale;

            }
        },
        computed: {
            ...mapGetters('globalization', [
                'locale',
            ])
        },
        created: function () {

            this.contentService = new ContentService();
        },
        mounted: async function () {
            await this.load();
        },
        methods: {
            load: async function () {
                console.log('load', this.name)
                try {
                    this.content = await this.contentService.getHtml({ name: this.name, locale: this.locale });
                }
                catch (ex) {
                    console.log(ex)
                }
            }
        }
    }
</script>
<style lang="sass">
</style>
